export const RESOLUTIONS = [
  4000, 3750, 3500, 3250, 3000, 2750, 2500, 2250, 2000, 1750, 1500, 1250, 1000,
  750, 650, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1.5, 1, 0.5,
];

export const TRACK_WIDTH = 5;

export const Z_INDEXES = {
  MASK: 11,
  HIGHLIGHT: 10,
  ROUTE_PHOTOS: 10,
  DETOURS_POINT: 9,
  ROUTE_LOGOS: 8,
  DETOURS_LINE: 7,
  TOURS: 5,
  POINT: 5,
  SLOWUP: 4,
  HIKING_TRAILS: 2.5,
  ROUTE: 2,
  OVERLAY: 1,
  BACKGROUND: 0,
};

export const QUERY_TOLERANCE = {
  default: 20,
  photo: 0,
  wildlife: 5,
};

export const DRAW_EXTENT = [2443048, 1030343, 2894802, 1339995];
